"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDataCount = exports.StyledAccordion = exports.Row = exports.Grid = exports.Col = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledDataSet = (0, _styledComponents.css)([".dataset-wrapper{.ds{&-row{display:flex;}&-col{flex:1;}&-count{", " color:", ";}}}.dataset{color:", ";&-title{padding:16px 24px;box-sizing:border-box;", "}&-row{border-bottom:1px solid ", ";&:first-child{border-top:1px solid ", ";}&.blbr{border-left:1px solid ", ";border-right:1px solid ", ";}}&-key,&-value{", " color:", ";padding:12px 12px 12px 24px;flex:1;}&-value{padding:12px 78px 12px 12px;text-align:right;color:", ";}}"], _shared.theme.typography.h6, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.h5, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5, _shared.theme.typography.h6, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.charcoal);

const StyledAccordion = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledAccordion",
  componentId: "sc-rxw8dc-0"
})(["width:100%;border:1px solid ", ";margin-bottom:16px;&:last-child{margin-bottom:0px;}border-radius:4px;.collapse-card-header{min-height:75px;.right{padding:24px;cursor:pointer;display:flex;flex:1;justify-content:flex-start;.card-icon{display:flex;align-items:center;.icon{transform:rotate(0deg);transition:transform 0.4s;}.icon.rotate{transform:rotate(180deg);}}.card-title{font-family:", ";font-size:18px;line-height:21px;margin-left:5px;display:flex;align-items:center;span{", " color:", ";margin-left:9px;line-height:initial;}}}.left{display:flex;justify-content:flex-end;padding:24px;}}.collapse-button{display:block;width:100%;}.collapse-content.collapsed{display:none;}.collapsed-content.expanded{display:block;}.renderer{padding-top:12px;}&.with-icon{.renderer{padding-left:20px;}}", ""], _shared.theme.palette.ui.neutral.grey5, _shared.theme.typography.caption.fontFamily, _shared.theme.typography.h6, _shared.theme.palette.brand.primary.gray, StyledDataSet);

exports.StyledAccordion = StyledAccordion;

const StyledDataCount = _styledComponents.default.span.withConfig({
  displayName: "styles__StyledDataCount",
  componentId: "sc-rxw8dc-1"
})(["", " color:", ";"], _shared.theme.typography.h6, _shared.theme.palette.brand.primary.gray);

exports.StyledDataCount = StyledDataCount;

const Grid = _styledComponents.default.div.withConfig({
  displayName: "styles__Grid",
  componentId: "sc-rxw8dc-2"
})([""]);

exports.Grid = Grid;

const Row = _styledComponents.default.div.withConfig({
  displayName: "styles__Row",
  componentId: "sc-rxw8dc-3"
})(["display:flex;", " ", " ", ""], ({
  justifyContent
}) => justifyContent && `justify-content: ${justifyContent};`, ({
  alignItems
}) => alignItems && `align-items: ${alignItems}; `, ({
  flexDirection
}) => flexDirection && `flex-direction: ${flexDirection};`);

exports.Row = Row;

const Col = _styledComponents.default.div.withConfig({
  displayName: "styles__Col",
  componentId: "sc-rxw8dc-4"
})(["", ""], ({
  flex
}) => flex && `flex: ${flex};`);

exports.Col = Col;